import Accordion from '../../plugins/accordion.js';
const elements = document.querySelectorAll(".js-accordion");
for (const element of elements) {
  let accordion2 = new Accordion(element, {
    // defaultOpenPanels: [0],
    multipleOpen: true,
    // onOpen: test,
    // onClose: fuga
  });
}


//開閉ボタンの挙動
const accordionItem = Array.from(document.querySelectorAll('.js-accordionItem'));

accordionItem.forEach((item) => {
  item.addEventListener('click', () => {
    let triggerBtn = item.querySelector('.js-accordion-trigger');
    if (triggerBtn.getAttribute('aria-expanded') == 'true') {
      item.classList.add('is-open');
    } else {
      item.classList.remove('is-open');
    }
  });
});

// let accordion = new Accordion(".js-accordion2", {
//   defaultOpenPanels: [0],
//   onOpen: hoge,
//   onClose: fuga
// });

// accordion.destroy()
// accordion.init()
